import { 
  User,          // 기본 정보 (아이디)
  Key,           // 비밀번호
  Users,         // 부모 영역 (가족/그룹)
  CreditCard,    // 자녀 영역 (여권 카드 형태)
  PlusCircle,    // 추가 버튼 (부모/자녀 추가)
  ChevronRight,  // (선택 사항) 상세 페이지 이동 시
  ShieldCheck    // (선택 사항) 인증 상태 표시 시
} from 'lucide-react';

const ChildrenSection = () => {
	return (
		<section className="space-y-6">
            <div className="flex items-center justify-between border-b pb-2">
              <div className="flex items-center gap-2">
                <CreditCard className="w-5 h-5 text-slate-600" />
                <h2 className="text-xl font-bold">자녀 여권 정보</h2>
              </div>
              <button className="px-4 py-1.5 bg-slate-900 text-white rounded-full text-sm font-medium hover:bg-slate-700 transition">
                자녀 추가
              </button>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* 여권 아이템 */}
              {[1, 2].map((child) => (
                <div key={child} className="group relative overflow-hidden rounded-[15px] border-2 border-slate-200 hover:border-blue-400 transition-all shadow-sm hover:shadow-md">
                  {/* 여권 상단 장식 */}
                  <div className="bg-blue-900 h-10 flex items-center px-4 justify-between">
                    <span className="text-[10px] text-blue-200 tracking-widest font-bold">REPUBLIC OF KOREA</span>
                    <div className="w-4 h-4 rounded-full border border-blue-400 opacity-50" />
                  </div>
                  <div className="p-5 flex gap-4">
                    <div className="w-24 h-32 bg-gray-200 rounded flex items-center justify-center text-gray-400 text-xs">
                      PHOTO
                    </div>
                    <div className="flex-1 text-left space-y-2">
                      <div>
                        <p className="text-[10px] text-gray-400 font-bold uppercase">Surname / Given Name</p>
                        <p className="font-bold text-lg">김자녀 {child}</p>
                      </div>
                      <div>
                        <p className="text-[10px] text-gray-400 font-bold uppercase">Passport No</p>
                        <p className="font-mono text-sm">M1234567{child}</p>
                      </div>
                      <div className="pt-2">
                        <span className="text-[10px] bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-bold">ACTIVE</span>
                      </div>
                    </div>
                  </div>
                  {/* 여권 하단 영역 */}
                  <div className="bg-gray-50 p-2 border-t text-[10px] font-mono text-gray-400 overflow-hidden whitespace-nowrap">
                    P&lt;KORNAME&lt;&lt;CHILD&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;
                  </div>
                </div>
              ))}
            </div>
          </section>
	);
}

export default ChildrenSection;